import styled from "vue-styled-components";

export const StyleCalendar = styled.div`
    position: relative;
    height: auto;
    width: auto;
    max-width: 300px;
    padding: 1rem;
    border: 1px solid ${props => props.theme?.calendar?.border_color ?? props.theme?.border_color_site ?? '#dee2e6'};
    background: ${props => props.theme?.background_color_site ?? '#fff'};
`;

export const CalendarHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid ${props => props.theme?.calendar?.border_color ?? props.theme?.border_color_site ?? '#dee2e6'};
    padding-bottom: 1rem;

    span, button i {
        color: ${props => props.theme?.calendar?.header?.color ?? props.theme?.text_site_color ?? '#4a505e'};
    }

    button {
        padding: 0.5rem 1.2rem;
        border: none;
        background: ${props => props.theme?.background_color_site ?? '#fff'};
        border-radius: 0.25rem;
        cursor: pointer;
        outline: none;
        transition: 0.2s;

        &:hover {
            background: ${props => props.theme?.calendar?.body?.day?.bg_active ?? '#f1f1f1'};
            i {
                color: ${props => props.theme?.calendar?.body?.day?.color_active ?? '#000'};
            }
        }

        &[disabled] {
            pointer-events: none;
            opacity: 0.7;
        }
    }

    span {
        font-size: ${props => props.theme?.calendar?.header?.font_size ?? '1.3rem'};
        font-weight: ${props => props.theme?.calendar?.header?.font_weight ?? '600'};
        letter-spacing: 0.5px;
        text-transform: ${props => props.theme?.calendar?.header?.text_transform ?? 'uppercase'};
    }
`;

export const CalendarBody = styled.div`
    div {
        display: flex;
        justify-content: space-between;
        padding-bottom: 1rem;

        span {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            gap: 0.3rem;
            width: 3.5rem;
            height: 3.5rem;
            font-size: ${props => props.theme?.calendar?.body?.day?.font_size ?? '1.3rem'};
            font-weight: ${props => props.theme?.calendar?.body?.day?.font_weight ?? '400'};
            border-radius: ${props => props.theme?.calendar?.body?.day?.border_radius ?? '50%'};
            cursor: pointer;
            color: ${props => props.theme?.calendar?.body?.day?.color ?? props.theme?.text_site_color ?? '#4a505e'};
            background: ${props => props.theme?.background_color_site ?? '#fff'};
            transition: 0.2s;

            &.active, &:hover {
                background: ${props => props.theme?.calendar?.body?.day?.bg_active ?? '#f1f1f1'};
                color: ${props => props.theme?.calendar?.body?.day?.color_active ?? '#000'};
            }
            
            &.disabled {
                pointer-events: none;
                opacity: 0.6;
            }

            &.holiday {
                color: ${props => props.theme?.calendar?.body?.day?.color_holiday ?? '#bb2c2c'};
            }
        }

        &.calendar-days-of-week {
            margin-bottom: 0.7rem;

            span {
                pointer-events: none;
                font-weight: ${props => props.theme?.calendar?.header?.font_weight ?? '600'};
            }
        }
    }    
`;

export const CalendarFooter = styled.div`
    display: flex;
    justify-content: space-between;
    gap: 0.5rem;
    border-top: 1px solid ${props => props.theme?.calendar?.border_color ?? props.theme?.border_color_site ?? '#dee2e6'};
    padding-top: 1rem;

    .btn-clock-delivery {
        background: transparent;
        padding: 0.6rem 1rem;
        transition: filter 0.3s;
        padding: 0.6rem 2rem;
        min-width: 1px;
        i {
            font-size: 2.2rem;
            color: ${props => props.theme?.calendar?.body?.day?.color ?? props.theme?.text_site_color ?? '#4a505e'};
        }

        &:hover {
            filter: brightness(0.5);
        }
    }

    > div {
        display: flex;
        gap: 0.5rem;
    }
`;
